// hook
import React, { useEffect, useState } from "react";
// routing
import { Navigate, Route, Routes } from "react-router-dom";
// links
import { routes } from "../../features/routes/route";
// errorText
import Error from "../../pages/client/error/error";
// canvas
import html2canvas from "html2canvas";
// modal
import Modal from "../../components/modal/modal";
// location
import { useLocation } from 'react-router-dom';
// cookie
// @ts-ignore
import Cookies from 'js-cookie';

const Router = (props: any) => {
    const location = useLocation();
    const ToCaptureRef: any = React.useRef();
    const [user, setUser] = useState<boolean>();
    const isAboutPage = location.pathname === routes.client[1].address;
    const hamiyanPage = location.pathname === routes.client[4].address;
    const ezdevajPage = location.pathname === routes.client[7].address;
    const captureScreenshot = () => {
        const originalWidth = ToCaptureRef.current.clientWidth;
        ToCaptureRef.current.style.width = "390px";
        html2canvas(ToCaptureRef.current, {
            useCORS: true,
            scale: 2,
        }).then((canvas: HTMLCanvasElement) => {
            ToCaptureRef.current.style.width = `${originalWidth}px`;
            canvas.toBlob((blob: any) => {
                if (navigator.share) {
                    // @ts-ignore
                    navigator.share({
                        files: [new File([blob], 'screenshot.png', { type: 'image/png' })]
                    })
                        .then(() => console.log('Successful share'))
                        .catch((error) => console.error('Error sharing', error));
                } else {
                    console.log('Web Share API not supported');
                }
            }, 'image/png');
        });
    }

    useEffect(() => {
        if (Cookies.get('auth')) {
            setUser(true)
        } else {
            setUser(false)
        }
    }, []);
    return (
        <>
            <main id='site-main' ref={ToCaptureRef}
                className={isAboutPage ? 'helpContent' : hamiyanPage ? 'helpContent hamiyanContent' : ezdevajPage ? 'helpContent ezdevajContent' : 'main-content'}>
                <Routes>
                    {routes.client.map((link: any) => (
                        <Route key={link.address} element={link.component} path={link.address} />
                    ))}
                    {routes.payment.map((link: any) => (
                        <Route key={link.address} element={link.component} path={link.address} />
                    ))}
                    {routes.authPay.map((link: any) => (
                        <Route key={link.address} element={link.component} path={link.address} />
                    ))}
                    {user && (
                        <>
                            {routes.auth.map((link: any) => (
                                <Route key={link.address} element={link.component} path={link.address} />
                            ))}
                        </>
                    )}
                    <Route path="/buy" element={<Navigate to="/" replace />} />
                    <Route element={<Error />} path={'*'} />
                </Routes>
            </main>
            <Modal captureScreenshot={() => captureScreenshot()} />
        </>
    )
}

export default Router;